"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _icons = require("@material-ui/icons");
var _reactDeviceDetect = require("react-device-detect");
var _contexts = require("../../contexts");
var _styles = _interopRequireDefault(require("./styles"));
var _themes = require("../../themes");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable react/jsx-no-bind */
// External Libraries

// Contexts

// Themes

var TOOLTIP_OFFLINE_MESSAGE = 'Fique online para acessar as funções da biblioteca digital saraiva';
function BottomNavigation() {
  var classes = (0, _styles.default)();
  var {
    isPageBookmarked
  } = (0, _react.useContext)(_contexts.BookmarksContext);
  var {
    isAppOffline,
    loadingLocations
  } = (0, _react.useContext)(_contexts.EpubReaderContext);
  var {
    openDrawer,
    handleDrawerActions,
    showingTooltip,
    setShowingTooltip
  } = (0, _react.useContext)(_contexts.SideBarContext);
  var {
    backgroundStyle
  } = (0, _react.useContext)(_contexts.ReaderPreferencesContext);
  var bgColor = _themes.EPUB_READER_THEMES[backgroundStyle].body.backgroundColor;
  var displayNav = openDrawer ? 'none' : 'flex';
  var buttonClass = backgroundStyle === 'dark' ? classes.bottomButtonsDM : classes.bottomButtons;
  var selectedClass = backgroundStyle === 'dark' ? classes.selectedButtonDM : classes.selectedButton;
  return /*#__PURE__*/_react.default.createElement(_core.BottomNavigation, {
    showLabels: true,
    classes: {
      root: classes.bottomWrapper
    },
    className: _reactDeviceDetect.isIOS13 || _reactDeviceDetect.isIOS ? classes.bottomIOS : classes.bottomWrapper,
    onChange: (event, newValue) => {
      if (isAppOffline) {
        return;
      }
      handleDrawerActions(event, newValue);
    },
    style: {
      backgroundColor: bgColor,
      display: displayNav
    }
  }, /*#__PURE__*/_react.default.createElement(_core.Tooltip, {
    open: showingTooltip === 'summaryNavigation' && isAppOffline,
    onOpen: () => setShowingTooltip('summaryNavigation'),
    onClose: () => setShowingTooltip(null),
    title: TOOLTIP_OFFLINE_MESSAGE,
    placement: "top",
    arrow: true,
    classes: {
      tooltip: classes.tooltip
    }
  }, /*#__PURE__*/_react.default.createElement(_core.BottomNavigationAction, {
    label: "Menu",
    icon: /*#__PURE__*/_react.default.createElement(_icons.FormatListBulleted, null),
    value: "summary",
    classes: {
      root: buttonClass
    },
    disabled: loadingLocations
  })), /*#__PURE__*/_react.default.createElement(_core.Tooltip, {
    open: showingTooltip === 'boookmarkNavigation' && isAppOffline,
    onOpen: () => setShowingTooltip('boookmarkNavigation'),
    onClose: () => setShowingTooltip(null),
    title: TOOLTIP_OFFLINE_MESSAGE,
    placement: "top",
    arrow: true,
    classes: {
      tooltip: classes.tooltip
    }
  }, /*#__PURE__*/_react.default.createElement(_core.BottomNavigationAction, {
    label: isPageBookmarked ? 'Página marcada' : 'Marcar página',
    icon: isPageBookmarked ? /*#__PURE__*/_react.default.createElement(_icons.Bookmark, null) : /*#__PURE__*/_react.default.createElement(_icons.BookmarkBorder, null),
    value: "toggleBookmark",
    classes: {
      root: buttonClass
    },
    className: isPageBookmarked && selectedClass,
    disabled: loadingLocations
  })), /*#__PURE__*/_react.default.createElement(_core.Tooltip, {
    open: showingTooltip === 'searchNavigation' && isAppOffline,
    onOpen: () => setShowingTooltip('searchNavigation'),
    onClose: () => setShowingTooltip(null),
    title: TOOLTIP_OFFLINE_MESSAGE,
    placement: "top",
    arrow: true,
    classes: {
      tooltip: classes.tooltip
    }
  }, /*#__PURE__*/_react.default.createElement(_core.BottomNavigationAction, {
    label: "Buscar",
    icon: /*#__PURE__*/_react.default.createElement(_icons.SearchOutlined, null),
    value: "search",
    classes: {
      root: buttonClass
    },
    disabled: loadingLocations
  })));
}
var _default = exports.default = BottomNavigation;